

import dayjs from 'dayjs'
import { enqueueSnackbar, closeSnackbar } from 'notistack'
import { IconButton } from '@mui/material'
import { CommonIcons, icons } from '../components/common/CommonIcons'

// import PropTypes from 'prop-types'

export function useSystemPrompt() {

    // promptMessage.propTypes = {
    //     type: PropTypes.bool,
    //     message: PropTypes.string,
    // }

    const RenderCloseButton = (key) => (
        <IconButton
            size="small"
            onClick={() => closeSnackbar(key)}
            sx={{ color: 'white' }}
        >
            <CommonIcons name={icons.close} fontSize="small" />
        </IconButton>
    )

    const promptMessage = (type, message, response = {}) => {

        const variant = type ? 'success' : 'error'
        let warnings = response?.warning ? response.warning : [];

        // const {
        //     persist = false,
        //     autoHideDuration = 2000
        // } = config

        // temp only
        // if(Object.keys(response).length){

        //     response = {
        //         // warning: [
        //         //     {
        //         //         title: "Document No: DO-23432423",
        //         //         message: "Failed to inbound for <BR>slot id : <a href='category/update/1234'>324</a> <BR>Items : anbsdfjsdlfjds kdsfjkldsj"
        //         //     },
        //         //     {
        //         //         title: "Document No: DO-23432423",
        //         //         message: "<p>Hello World</p><BR>dsfsdfdsfds sdfsdf sdf sdfsd fds dsf ssfd"
        //         //     },
        //         // ]
        //         warning:
        //     }

        //     warnings = response?.warning? response.warning : []
        // }

        // hub-cn users want messages to hide by themselves; hub-my keeps them until closed.
        const hostname = window.location.hostname;
        const autoHide = hostname === "hub-cn.sdgroup.com.my";

        const _props = {
            variant,
            persist: !autoHide,
            autoHideDuration: autoHide ? 2000 : undefined,
            preventDuplicate: true,
            action: RenderCloseButton
        }

        if (warnings.length > 0) {

            const id = dayjs().unix();

            enqueueSnackbar(
                `You have warnings with action performed`,
                {
                    ..._props,
                    key: id,
                    persist: true,
                    variant: "commonNotistack",
                    data: warnings,
                    icon: () => <CommonIcons name={icons.warning} sx={{ mx: 1 }} />,
                }
            )

        } else {
            enqueueSnackbar(
                message,
                {
                    ..._props,
                }
            )
        }


    }

    return { promptMessage }
}